import { CopyIcon } from 'lucide-react';
import { useCopyToClipboard } from 'usehooks-ts';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { Button } from '../button.tsx';
import { DropdownMenuItem } from '../dropdown-menu.tsx';
import { useToast } from '../use-toast.tsx';

const useCopy = (textToCopy: string) => {
    const [, copy] = useCopyToClipboard();
    const { toast } = useToast();
    const { t } = useLocale();

    const onCopy = () => {
        copy(textToCopy);

        toast({
            icon: 'success',
            title: t('copy_successful', { ns: 'toasts' }),
        });
    };

    return { onCopy, t };
};

type CopyButtonProps = {
    className?: string;
    title?: string;
    textToCopy: string;
};

export const CopyButton: React.FC<CopyButtonProps> = ({ className, textToCopy, title }) => {
    const { onCopy, t } = useCopy(textToCopy);

    return (
        <Button
            className={className}
            icon={CopyIcon}
            variant={title === '' ? 'icon' : 'subtle'}
            onClick={onCopy}
        >
            {title === undefined
                ? t('copy_id', {
                      ns: 'common',
                  })
                : title}
        </Button>
    );
};

type DropdownMenuItemCopyProps = {
    textToCopy: string;
    className?: string;
};

export const DropdownMenuItemCopy: React.FC<DropdownMenuItemCopyProps> = ({ textToCopy, className }) => {
    const { onCopy, t } = useCopy(textToCopy);

    return (
        <DropdownMenuItem onSelect={onCopy} className={className}>
            <CopyIcon className="h-4 w-4" />
            <span>{t('copy_id', { ns: 'common' })}</span>
        </DropdownMenuItem>
    );
};
